<button class="btn shadow-none border-none" (click)="onButtonClick($event)">
    <app-svg-icon icon="share-new" color="#000" padding="10px"></app-svg-icon>
</button>
